import React, { useEffect, useState } from 'react';
import axios from 'axios';
import FormationSection from "../components/accueil/formations";
import LoaderAnimation from "../lib/loaderAnimation";

const FormationDataComponent = ({ container, containerIndex, nbrItem }) => {
    const [formationData, setFormationData] = useState([]);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const [loadingFormation, setLoadingFormation] = useState(true);
    const [pageFormationError, setPageFormationError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoadingFormation(true);
            try {
                const response = await axios.get( `${apiUrl}/front_formations?statut=1&itemsPerPage=${nbrItem}`);
                setFormationData(response.data);
                setLoadingFormation(false);
            } catch (error) {
                setPageFormationError(true);
                console.error('Erreur lors de la récupération des données :', error);
            }
        };

        fetchData();
    }, [apiUrl, nbrItem]);

    return (
        <React.Fragment key={`banner-${containerIndex}`}>
        {loadingFormation ? (
            <LoaderAnimation version={"2"}/>
        ) : (
            <FormationSection
                nbrItem={nbrItem}
                container={container}
                formationData={formationData}
                containerIndex={containerIndex}
            />
        )}
        </React.Fragment>
    );
};

export default FormationDataComponent;